import { produce } from 'immer';
import { AUTH_LOGOUT } from '../actions';
import {
  NOTIFICATION_DETAILS_GET,
  NOTIFICATION_DETAILS_RESET,
  NOTIFICATION_GET,
} from '../actions/notifications';

const initialState = {
  data: [],
  headerNotification: [],
  email: undefined,
  pager: {},
  details: {},
};

const notificationReducer = (state = initialState, action) =>
  produce(state, (draft) => {
    switch (action.type) {
      case AUTH_LOGOUT._SUCCESS: {
        draft = initialState;
        break;
      }

      case NOTIFICATION_GET._SUCCESS: {
        const { response, saveIn } = action;
        if (saveIn === 'header') {
          draft.headerNotification = response?.data || [];
        } else if (saveIn === 'pageOnly') {
          draft.data = response?.data || [];
          draft.pager = response?.pager || {};
        } else {
          draft.headerNotification = response?.data || [];
          draft.data = response?.data || [];
          draft.pager = response?.pager || {};
        }
        break;
      }

      case NOTIFICATION_DETAILS_GET._SUCCESS: {
        const { data } = action;
        draft.details = data?.notification || {};
        break;
      }

      case NOTIFICATION_DETAILS_RESET: {
        draft.details = initialState.details;
        break;
      }

      default:
        return state;
    }
    return draft;
  });

export default notificationReducer;
